import { createAction } from 'redux-actions';
import { SelectedServiceType, SelectedSeatsServiceType, SelectedServicesState } from './reducers';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

export const ADD_SERVICE = 'ADD_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const ADD_SERVICE_NS = 'ADD_SERVICE_NS'; // _NS  - No Saga
export const REMOVE_SERVICE_NS = 'REMOVE_SERVICE_NS';
export const SET_SERVICE = 'SET_SERVICE';
export const SAVE_SERVICES = 'SAVE_SERVICES';
export const SET_ALL_SELECTED_SERVICES = 'SET_ALL_SELECTED_SERVICES';
export const DELETE_ALL_TYPES_ON_SEGMENT = 'DELETE_ALL_TYPES_ON_SEGMENT';
export const DELETE_ALL_TYPES_ON_SEGMENT_NS = 'DELETE_ALL_TYPES_ON_SEGMENT_NS';
export const CLEAR_ALL_SERVICES = 'CLEAR_ALL_SERVICES';
export const SET_MULTIPLE_SELECTED_SERVICES = 'SET_MULTIPLE_SELECTED_SERVICES';
export const SET_MULTIPLE_SELECTED_SERVICES_NS = 'SET_MULTIPLE_SELECTED_SERVICES_NS';

export interface ServicePayloadExtraValues {
	type: string;
	name?: string;
	value?: string;
}

export interface ServicePayload {
	passengerId: string;
	segmentId: string;
	segmentIds?: string[];
	allowedSegments?: string[][];
	service?: SelectedServiceType | SelectedSeatsServiceType;
	serviceId: string;
	count?: number;
	extraValues?: ServicePayloadExtraValues[];
}

export type ServicePayloadWithExtraValues = ServicePayload & { extraValues?: ServicePayloadExtraValues[] };

export type SetServicesAction = SelectedServicesState;

export type ServiceMeta = { custom_ecommerce_name: string };

export interface DeleteAllOnSegmentAction {
	type?: OrderAdditionalServiceGdsServiceServiceType;
	segmentId?: string;
	serviceId?: string;
	deleteOnAllSegments?: boolean;
}

export const addServiceAction = createAction<ServicePayload>(ADD_SERVICE);
export const removeServiceAction = createAction<ServicePayload>(REMOVE_SERVICE);
export const addServiceAction_NS = createAction<ServicePayload>(ADD_SERVICE_NS); // _NS - No Saga
export const removeServiceAction_NS = createAction<ServicePayload>(REMOVE_SERVICE_NS);
export const setServiceAction = createAction<ServicePayload>(SET_SERVICE);
export const saveServicesAction = createAction<Partial<ServicePayload>>(SAVE_SERVICES);
export const setMultipleSelectedServices: (
	payload: ServicePayload[],
	meta?: ServiceMeta
) => { type: string; payload: ServicePayload[]; meta?: ServiceMeta } = createAction(
	SET_MULTIPLE_SELECTED_SERVICES,
	(payload: ServicePayload[]) => payload,
	(_: ServicePayload[], meta: ServiceMeta) => meta
);
export const setMultipleSelectedServicesAction_NS = createAction<ServicePayload[]>(SET_MULTIPLE_SELECTED_SERVICES_NS);
export const setAllSelectedServices = createAction<SetServicesAction>(SET_ALL_SELECTED_SERVICES);
export const deleteAllTypesOnSegment = createAction<DeleteAllOnSegmentAction>(DELETE_ALL_TYPES_ON_SEGMENT);
export const deleteAllTypesOnSegmentAction_NS = createAction<DeleteAllOnSegmentAction>(DELETE_ALL_TYPES_ON_SEGMENT_NS);
